export default "__VITE_ASSET__BkDKPvid__"